import { NgModule } from '@angular/core';
import { DimensoesIdssChartComponent } from './dimensoes-idss-chart.component';

@NgModule({
  declarations: [DimensoesIdssChartComponent],
  exports: [DimensoesIdssChartComponent],
})
export class DimensoesIdssChartModule {}
